export enum LoadMoreStatusEnum {
  MORE = 'MORE',
  NO_MORE = 'NO_MORE'
}